var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullscreenSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z",
    fill: "#1C53EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.769 23.0324H10.519V23.2824V27.6926C10.519 28.1735 10.7024 28.5949 11.0538 28.9463C11.4052 29.2977 11.8266 29.4811 12.3075 29.4811H16.7178H16.9678V29.2311V27.6926V27.4426H16.7178H12.5575V23.2824V23.0324H12.3075H10.769ZM23.0319 29.2311V29.4811H23.2819H27.6921C28.173 29.4811 28.5944 29.2977 28.9458 28.9463C29.2972 28.5949 29.4806 28.1735 29.4806 27.6926V23.2824V23.0324H29.2306H27.6921H27.4421V23.2824V27.4426H23.2819H23.0319V27.6926V29.2311ZM10.519 16.7182V16.9682H10.769H12.3075H12.5575V16.7182V12.558H16.7178H16.9678V12.308V10.7695V10.5195H16.7178H12.3075C11.8266 10.5195 11.4052 10.7029 11.0538 11.0543C10.7024 11.4057 10.519 11.8271 10.519 12.308V16.7182ZM27.4421 16.7182V16.9682H27.6921H29.2306H29.4806V16.7182V12.308C29.4806 11.8271 29.2972 11.4057 28.9458 11.0543C28.5944 10.7029 28.173 10.5195 27.6921 10.5195H23.2819H23.0319V10.7695V12.308V12.558H23.2819H27.4421V16.7182Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenSelected);
export default __webpack_public_path__ + "static/media/fullscreen-selected.7ee6c6ac62203a7d440ec20d61758adf.svg";
export { ForwardRef as ReactComponent };